// src/hooks/paxTypes/useDeleteAllPaxTypes.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllPaxTypes as deleteAllPaxTypesAPI } from "../../api/apiPaxTypes";
import parseError from "../../utils/parseError";

const useDeleteAllPaxTypes = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteAll, isPending: isDeleteAll } = useMutation({
        mutationFn: deleteAllPaxTypesAPI,
        onSuccess: (res) => {
            const message = res?.message || "Selected pax types deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["paxTypes"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete selected pax types");
        },
    });

    return { deleteAllPaxTypes: deleteAll, isDeleteAll };
};

export default useDeleteAllPaxTypes;